export default "__VITE_ASSET__DnVtKQeX__"